import React from 'react';
import Skeleton from '@common_skeleton';
import { useTranslation } from 'next-i18next';
import { getGuestRewards, getRewardsOfProduct, getRewards } from '@core_modules/amrewards/services/graphql';
import Show from '@common/Show';
import Typography from '@common/Typography';
import cx from 'classnames';
import { getLoginInfo } from '@helper_auth';
import Link from 'next/link';
import { formatPoint } from '@helpers/points';

const caption = (props) => {
    const {
        pageId = '0',
        className = '',
        isPLP = false,
        dataHighlights = {},
        productId = 1,
        isPDP = false,
        isCartPage = false,
        isCheckoutPage = false,
        showLinkRegistration = false,
    } = props;

    const { t } = useTranslation(['common']);
    const isLogin = getLoginInfo();

    const { data: dataGuest, loading: loadingGuest, error: errorGuest } = getGuestRewards({
        variables: {
            page: parseInt(pageId, 10),
        },
        skip: isPLP || isLogin,
    });

    const { data: dataRewardsOfProducts } = getRewardsOfProduct({
        variables: {
            productId: parseInt(productId, 10),
        },
        skip: !isLogin || !isPDP,
    });

    const { data: dataRewardsCart } = getRewards({
        skip: (!isCartPage || !isCheckoutPage) && !isLogin,
    });

    let Highlight = {
        color: null,
        visible: null,
        caption_text: null,
    };

    if (isPLP) {
        Highlight = { ...dataHighlights };
    } else if (!isPLP && isLogin && !isCartPage && !isCheckoutPage) {
        Highlight = dataRewardsOfProducts?.rewards?.highlight?.category;
    } else if ((isCartPage || isCheckoutPage) && isLogin) {
        Highlight = dataRewardsCart?.rewards?.highlight?.cart;
    } else {
        Highlight = dataGuest?.guestRewards;
    }

    const isVisible = Highlight?.visible;
    const points = formatPoint(Highlight?.caption_text);
    const color = Highlight?.caption_color;

    if (loadingGuest && !errorGuest && !dataGuest && !isPLP) {
        return (
            <div className={cx('relative block my-4', className)}>
                <Skeleton width="60%" height={30} />
            </div>
        );
    }

    return (
        <>
            <Show when={isVisible}>
                {isPLP ? (
                    <>
                        <Typography variant="p-1">
                            {t('common:amrewards:earn')}
                            {' '}
                            <span className="point-earn font-semibold">
                                {t('common:amrewards:points', { points })}
                            </span>
                        </Typography>
                    </>
                ) : (
                    <div className={cx('relative block my-4', className)}>
                        <Typography variant="p-1">
                            {t('common:amrewards:caption_earn')}
                            {' '}
                            <span className="point-earn font-semibold">
                                {isPLP ? (
                                    <>
                                        {t('common:amrewards:points', { points })}
                                    </>
                                ) : (
                                    <>
                                        {t('common:amrewards:point_rewards', { points })}
                                    </>
                                )}
                            </span>
                            {' '}
                            {isLogin ? (
                                <>
                                    {isCartPage ? t('common:amrewards:caption_completepurchase') : t('common:amrewards:caption_buyproduct')}
                                </>
                            ) : (
                                <>
                                    <Show when={showLinkRegistration}>
                                        <Link href="/customer/account/create">
                                            <span className="underline">
                                                {t('common:amrewards:caption_forregistration')}
                                            </span>
                                        </Link>
                                    </Show>
                                </>
                            )}
                        </Typography>
                    </div>
                )}
                <style global jsx>
                    {`
                        .point-earn {
                            color: ${color};
                        }
                    `}
                </style>
            </Show>
        </>
    );
};

export default caption;
